import React from "react";
import { Link, useParams } from "react-router-dom";

import { useTranslation } from "react-i18next";

export function SportsAndStatisticsLink() {
	const t = useTranslation().t;
	const params = useParams<{ culture: string }>();
	return (
		<>
			<div className="col col-sml-12 col-med-12 col-lrg-6 col-xlrg-6 u-mar--bottom--xsml">
				<div className="card--empty card--empty--grow">
					<div className="card--empty__content">
						<i className="card--empty__icon u-icon u-icon--huge u-icon--empty--sports" />
						<div className="card--empty__title">
							{t("LIVE.SPORTS_BETTING")}
						</div>
						<div className="card--empty__message">
							<div>
								<span className="u-separator--disc" />
								{t("LIVE.PLACE_BETS")}
							</div>
							<div>
								<span className="u-separator--disc" />
								{t("LIVE.CASH_OUT")}
							</div>
						</div>
						<Link
							to={`/${params.culture}/sports/full`}
							className="card--empty__btn btn btn--sml btn--primary--inverted btn--icon btn--animate-forward"
						>
							{t("LIVE.GO_SPORTS_BETTING")}
							<i className="u-icon u-icon--tny u-icon--arrow-right" />
						</Link>
					</div>
				</div>
			</div>
			<div className="col col-sml-12 col-med-12 col-lrg-6 col-xlrg-6 u-mar--bottom--xsml">
				<div className="card--empty card--empty--grow">
					<div className="card--empty__content">
						<i className="card--empty__icon u-icon u-icon--huge u-icon--empty--stats" />
						<div className="card--empty__title">
							{t("LIVE.BET_STATISTICS")}
						</div>
						<div className="card--empty__message">
							<div>
								<span className="u-separator--disc" />
								{t("LIVE.FOLLOW_STATISTICS")}
							</div>
							<div>
								<span className="u-separator--disc" />
								{t("LIVE.WE_OFFER_HUGE_OVERVIEW")}
							</div>
						</div>
						<a
							href={"https://s5.sir.sportradar.com/tipwin/"}
							className="card--empty__btn btn btn--sml btn--primary--inverted btn--icon btn--animate-forward"
							target="_blank"
						>
							{t("LIVE.CHECK_STATISTICS")}
							<i className="u-icon u-icon--tny u-icon--arrow-right" />
						</a>
					</div>
				</div>
			</div>
		</>
	);
}
